import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, inject, signal } from '@angular/core';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Backend } from 'src/app/backend-interface/backend';
import { ClientApplication, Policy } from 'src/app/service/global.service';
import { TranslationService } from 'src/app/service/translation.service';


/**
 * Child component for confirmation modal according to the type of action : refuse, accept, submit
 */
@Component({
    selector: 'app-confirmation-form',
    templateUrl: './confirmation-form.component.html',
    styleUrls: ['./confirmation-form.component.scss'],
    providers: [DatePipe],
    imports: [
      TranslateModule,
      NgbDropdownModule,
      NgbTooltipModule
    ],
    standalone: true
})
export class ConfirmationFormComponent implements OnInit {

  @Input() policy ?: Policy
  @Input() type?: string

  @Output() closeEvent = new EventEmitter<string>()
  @Output() action = new EventEmitter<string>()

  @Output() eventSubmit = new EventEmitter<number>()

  readonly continue = signal<boolean>(false);
  readonly lApplications = signal<ClientApplication[] | undefined>(undefined);
  readonly selectedApp = signal<number | undefined>(undefined);

  readonly datepipe = inject(DatePipe);

  readonly translationService = inject(TranslationService);

  /**
   * Initialize display and the application selection only if this component is called for submit
   */
  ngOnInit(): void {
    if (this.type == "submit") {
      this.continue.set(false);
      Backend.POLICIES.getAllApplication(this.policy).then(apps => {
        this.lApplications.set(apps);
        this.selectedApp.set(apps?.[0]?.id);
      });
    }
  }

  /** send an event for close the modal */
  public sendclose(c:string){
    this.closeEvent.emit(c)
  }

  public findAppli(){
    return this.lApplications()?.find(elem=> elem.id === this.selectedApp())
  }

  public send(ac:string){
    this.action.emit(ac)
    this.sendclose('Cross click')
  }

  timestampToDate(time: string) {
    const timestamp = new Date(time)
    return Backend.FORMAT.timestampToDate(timestamp.getTime(), this.datepipe, this.translationService.getDatePipeLang()) ?? '';
  }

  horaire(time: string) {
    const timestamp = new Date(time)
    return Backend.FORMAT.horaire(timestamp.getTime(), this.datepipe)
  }

  /** Send clientappid for submit fonctionnality */
  public emitClientAppID(){
    if (this.selectedApp()) {
      this.eventSubmit.emit(this.selectedApp());
    }
    this.sendclose('Cross click')
  }
}
